export default "__VITE_ASSET__D5_UImzW__"